import { useQuery, useQueryClient } from '@tanstack/react-query'
import { useCallback } from 'react'
import { api, ApiHttpError } from '~/lib/api/client'
import type { PersonSnapshot } from '~/lib/api/types'

export const PERSON_QUERY_KEY = (slackId: string, days: number, tz: string) =>
  ['person', slackId, days, tz] as const

export function usePersonSnapshot(
  slackId: string | undefined,
  days: number,
  tz: string
) {
  return useQuery<PersonSnapshot, ApiHttpError>({
    queryKey: PERSON_QUERY_KEY(slackId ?? '', days, tz),
    queryFn: () => api.getPerson(slackId as string, days, tz),
    enabled: Boolean(slackId),
    refetchOnWindowFocus: true,
    staleTime: 30 * 1000,
  })
}

export function useInvalidatePerson() {
  const qc = useQueryClient()
  return useCallback(
    (slackId: string, days: number, tz: string) => {
      qc.invalidateQueries({ queryKey: PERSON_QUERY_KEY(slackId, days, tz) })
    },
    [qc]
  )
}
